// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ReferenceDocumentDTO } from '../models';
/**
 * ReferenceDocumentsApi - axios parameter creator
 * @export
 */
export const ReferenceDocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Attach a Document to a Reference
         * @param {string} referenceId Reference id
         * @param {any} file 
         * @param {string} name 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addReferenceDocument(referenceId: string, file: any, name: string, type: string, options: any = {}): RequestArgs {
            // verify required parameter 'referenceId' is not null or undefined
            if (referenceId === null || referenceId === undefined) {
                throw new RequiredError('referenceId','Required parameter referenceId was null or undefined when calling addReferenceDocument.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling addReferenceDocument.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new RequiredError('name','Required parameter name was null or undefined when calling addReferenceDocument.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling addReferenceDocument.');
            }
            const localVarPath = `/v2/references/{referenceId}/documents`
                .replace(`{${"referenceId"}}`, encodeURIComponent(String(referenceId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
    
            if (type !== undefined) { 
                localVarFormParams.append('type', type as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete Reference Document by id
         * @param {string} referenceId Reference id
         * @param {string} documentId Reference Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReferenceDocument(referenceId: string, documentId: string, options: any = {}): RequestArgs {
            // verify required parameter 'referenceId' is not null or undefined
            if (referenceId === null || referenceId === undefined) {
                throw new RequiredError('referenceId','Required parameter referenceId was null or undefined when calling deleteReferenceDocument.');
            }
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new RequiredError('documentId','Required parameter documentId was null or undefined when calling deleteReferenceDocument.');
            }
            const localVarPath = `/v2/references/{referenceId}/documents/{documentId}`
                .replace(`{${"referenceId"}}`, encodeURIComponent(String(referenceId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Reference Documents by for a Reference by id
         * @param {string} referenceId Reference id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findManyReferenceDocuments(referenceId: string, options: any = {}): RequestArgs {
            // verify required parameter 'referenceId' is not null or undefined
            if (referenceId === null || referenceId === undefined) {
                throw new RequiredError('referenceId','Required parameter referenceId was null or undefined when calling findManyReferenceDocuments.');
            }
            const localVarPath = `/v2/references/{referenceId}/documents`
                .replace(`{${"referenceId"}}`, encodeURIComponent(String(referenceId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a reference Document by id
         * @param {string} referenceId Reference id
         * @param {string} documentId Reference Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReferenceDocumentById(referenceId: string, documentId: string, options: any = {}): RequestArgs {
            // verify required parameter 'referenceId' is not null or undefined
            if (referenceId === null || referenceId === undefined) {
                throw new RequiredError('referenceId','Required parameter referenceId was null or undefined when calling findReferenceDocumentById.');
            }
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new RequiredError('documentId','Required parameter documentId was null or undefined when calling findReferenceDocumentById.');
            }
            const localVarPath = `/v2/references/{referenceId}/documents/{documentId}`
                .replace(`{${"referenceId"}}`, encodeURIComponent(String(referenceId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReferenceDocumentsApi - functional programming interface
 * @export
 */
export const ReferenceDocumentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Attach a Document to a Reference
         * @param {string} referenceId Reference id
         * @param {any} file 
         * @param {string} name 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addReferenceDocument(referenceId: string, file: any, name: string, type: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferenceDocumentDTO> {
            const localVarAxiosArgs = ReferenceDocumentsApiAxiosParamCreator(configuration).addReferenceDocument(referenceId, file, name, type, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete Reference Document by id
         * @param {string} referenceId Reference id
         * @param {string} documentId Reference Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReferenceDocument(referenceId: string, documentId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = ReferenceDocumentsApiAxiosParamCreator(configuration).deleteReferenceDocument(referenceId, documentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get all Reference Documents by for a Reference by id
         * @param {string} referenceId Reference id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findManyReferenceDocuments(referenceId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReferenceDocumentDTO>> {
            const localVarAxiosArgs = ReferenceDocumentsApiAxiosParamCreator(configuration).findManyReferenceDocuments(referenceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a reference Document by id
         * @param {string} referenceId Reference id
         * @param {string} documentId Reference Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReferenceDocumentById(referenceId: string, documentId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferenceDocumentDTO> {
            const localVarAxiosArgs = ReferenceDocumentsApiAxiosParamCreator(configuration).findReferenceDocumentById(referenceId, documentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ReferenceDocumentsApi - factory interface
 * @export
 */
export const ReferenceDocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Attach a Document to a Reference
         * @param {string} referenceId Reference id
         * @param {any} file 
         * @param {string} name 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addReferenceDocument(referenceId: string, file: any, name: string, type: string, options?: any) {
            return ReferenceDocumentsApiFp(configuration).addReferenceDocument(referenceId, file, name, type, options)(axios, basePath);
        },
        /**
         * Delete Reference Document by id
         * @param {string} referenceId Reference id
         * @param {string} documentId Reference Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReferenceDocument(referenceId: string, documentId: string, options?: any) {
            return ReferenceDocumentsApiFp(configuration).deleteReferenceDocument(referenceId, documentId, options)(axios, basePath);
        },
        /**
         * Get all Reference Documents by for a Reference by id
         * @param {string} referenceId Reference id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findManyReferenceDocuments(referenceId: string, options?: any) {
            return ReferenceDocumentsApiFp(configuration).findManyReferenceDocuments(referenceId, options)(axios, basePath);
        },
        /**
         * Get a reference Document by id
         * @param {string} referenceId Reference id
         * @param {string} documentId Reference Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReferenceDocumentById(referenceId: string, documentId: string, options?: any) {
            return ReferenceDocumentsApiFp(configuration).findReferenceDocumentById(referenceId, documentId, options)(axios, basePath);
        },
    };
};

/**
 * ReferenceDocumentsApi - interface
 * @export
 * @interface ReferenceDocumentsApi
 */
export interface ReferenceDocumentsApiInterface {
    /**
     * Attach a Document to a Reference
     * @param {string} referenceId Reference id
     * @param {any} file 
     * @param {string} name 
     * @param {string} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDocumentsApiInterface
     */
    addReferenceDocument(referenceId: string, file: any, name: string, type: string, options?: any): AxiosPromise<ReferenceDocumentDTO>;

    /**
     * Delete Reference Document by id
     * @param {string} referenceId Reference id
     * @param {string} documentId Reference Document id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDocumentsApiInterface
     */
    deleteReferenceDocument(referenceId: string, documentId: string, options?: any): AxiosPromise<{}>;

    /**
     * Get all Reference Documents by for a Reference by id
     * @param {string} referenceId Reference id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDocumentsApiInterface
     */
    findManyReferenceDocuments(referenceId: string, options?: any): AxiosPromise<Array<ReferenceDocumentDTO>>;

    /**
     * Get a reference Document by id
     * @param {string} referenceId Reference id
     * @param {string} documentId Reference Document id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDocumentsApiInterface
     */
    findReferenceDocumentById(referenceId: string, documentId: string, options?: any): AxiosPromise<ReferenceDocumentDTO>;

}

/**
 * ReferenceDocumentsApi - object-oriented interface
 * @export
 * @class ReferenceDocumentsApi
 * @extends {BaseAPI}
 */
export class ReferenceDocumentsApi extends BaseAPI implements ReferenceDocumentsApiInterface {
    /**
     * Attach a Document to a Reference
     * @param {string} referenceId Reference id
     * @param {any} file 
     * @param {string} name 
     * @param {string} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDocumentsApi
     */
    public addReferenceDocument(referenceId: string, file: any, name: string, type: string, options?: any) {
        return ReferenceDocumentsApiFp(this.configuration).addReferenceDocument(referenceId, file, name, type, options)(this.axios, this.basePath);
    }

    /**
     * Delete Reference Document by id
     * @param {string} referenceId Reference id
     * @param {string} documentId Reference Document id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDocumentsApi
     */
    public deleteReferenceDocument(referenceId: string, documentId: string, options?: any) {
        return ReferenceDocumentsApiFp(this.configuration).deleteReferenceDocument(referenceId, documentId, options)(this.axios, this.basePath);
    }

    /**
     * Get all Reference Documents by for a Reference by id
     * @param {string} referenceId Reference id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDocumentsApi
     */
    public findManyReferenceDocuments(referenceId: string, options?: any) {
        return ReferenceDocumentsApiFp(this.configuration).findManyReferenceDocuments(referenceId, options)(this.axios, this.basePath);
    }

    /**
     * Get a reference Document by id
     * @param {string} referenceId Reference id
     * @param {string} documentId Reference Document id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDocumentsApi
     */
    public findReferenceDocumentById(referenceId: string, documentId: string, options?: any) {
        return ReferenceDocumentsApiFp(this.configuration).findReferenceDocumentById(referenceId, documentId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for ReferenceDocumentsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Attach a Document to a Reference
 * @param {string} referenceId Reference id
 * @param {any} file 
 * @param {string} name 
 * @param {string} type 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function addReferenceDocument(
    referenceId: string,
    file: any,
    name: string,
    type: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ReferenceDocumentDTO> {
    const localVarAxiosArgs = ReferenceDocumentsApiAxiosParamCreator(configuration).addReferenceDocument(referenceId, file, name, type, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete Reference Document by id
 * @param {string} referenceId Reference id
 * @param {string} documentId Reference Document id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deleteReferenceDocument(
    referenceId: string,
    documentId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = ReferenceDocumentsApiAxiosParamCreator(configuration).deleteReferenceDocument(referenceId, documentId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get all Reference Documents by for a Reference by id
 * @param {string} referenceId Reference id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function findManyReferenceDocuments(
    referenceId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<ReferenceDocumentDTO>> {
    const localVarAxiosArgs = ReferenceDocumentsApiAxiosParamCreator(configuration).findManyReferenceDocuments(referenceId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get a reference Document by id
 * @param {string} referenceId Reference id
 * @param {string} documentId Reference Document id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function findReferenceDocumentById(
    referenceId: string,
    documentId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ReferenceDocumentDTO> {
    const localVarAxiosArgs = ReferenceDocumentsApiAxiosParamCreator(configuration).findReferenceDocumentById(referenceId, documentId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

